import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-vendor-price-rate-for-approval',
  templateUrl: './vendor-price-rate-for-approval.component.html',
  styleUrls: ['./vendor-price-rate-for-approval.component.scss']
})
export class VendorPriceRateForApprovalComponent implements OnInit {

  public vendorList: any = [];
  public selectedVendor: any = null;
  public showVendorDetails: boolean = false;

  constructor(
    public vendorService: VendorDashboardService,
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    this.loadVendorList();
  }

  loadVendorList() {
    this.vendorService.getVendorRegNamesForApproval().pipe(first()).subscribe({
      next: (res) => {
        if(res.length > 0){
          this.vendorList = res;
        }
        else{
          this.vendorList = [];
          this.messageService.add({ severity: 'warn', summary: 'No Data Found', detail: 'No Vendor Found For Approval' });
        }
      },
      error: (err) => {
        this.vendorList = [];
        this.messageService.add({ severity: 'error', summary: 'Data Error', detail: err });
      }
    })
  }

  onSelectVendor(){
      this.showVendorDetails = true;
    }
}
